module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.payments), function(payment, index) {
    return _c('div', {
      key: index,
      staticClass: "pay-in__created-payment mb-2"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-start"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('reference-avatar', {
      staticClass: "mr-2",
      attrs: {
        "reference": payment.reference,
        "index": index
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "fs-small font-weight-600 darker"
    }, [_vm._v(_vm._s(payment.reference))]), _vm._v(" "), _c('div', {
      staticClass: "fs-small darkest"
    }, [_vm._v(_vm._s(_vm.truncateLabel(payment.itemsLabel)))]), _vm._v(" "), _vm._l((payment.paymentMethods), function(method, methodIndex) {
      return _c('div', {
        key: methodIndex,
        staticClass: "fs-small darkest"
      }, [_vm._v(_vm._s(method.typeName) + " " + _vm._s(method.amountReceived) + " €")])
    })], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-start mt-1 pay-in__created-payment-actions"
    }, [_c('i', {
      staticClass: "ico ico-edit dark fs-small pointer",
      on: {
        "click": function($event) {
          return _vm.$emit('edit', index)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "ico ico-delete dark fs-small pointer",
      on: {
        "click": function($event) {
          return _vm.$emit('remove', index)
        }
      }
    })])])])
  }), _vm._v(" "), (_vm.showAddPayment) ? _c('div', {
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "pay-in__add-method",
    class: {
      'pay-in__add-method--disabled': _vm.disableAdd
    },
    on: {
      "click": _vm.onAddPayment
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1 mr-1"
  }), _vm._v(" Add payment\n        ")])]) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-61500ca6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61500ca6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn/CreatedPartialPaymentList.vue
// module id = 2019
// module chunks = 0